module.exports = __webpack_public_path__ + "static/media/YM90_6.d5e8f0a3.jpg";